import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import waitlist from '../../assets/waitlist.svg';
import addIcon from '../../assets/add.svg';

import poSearchFiltersStyles from './poSearchFilters.module.css';

import { UserRoleType } from '../../models/User';
import { Badge } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import unrecognized from '../../assets/unlink_white.svg';

const styles = (theme: Theme) =>

  createStyles({
    input: {
      width: '150px'
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    select: {
      width: '110px'
    },
    button: {
      width: '100px',
      height: '40px'
    },
    textField: {
      color: 'var(--primaryblue)'
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    textFieldsDisabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    datePicker: {
      width: '150px'
    },
    helperText: {
      color: 'red'
    },
    inputSize: {
      padding: '11px 14px',
      width: '190px'
    },
    textFieldLabel: {
      transform: 'translate(14px, 12px) scale(1)'
    },
    manualEntryBtn: {
      fontSize: '50px',
      '&:hover': {
        cursor: 'pointer'
      },
    },
    badge: {
      '&>span': {
        marginTop: '11px',
      }
    },
    unRecIcon: {
      backgroundColor: 'var(--primaryblue)',
      width: '40px',
      height: '40px',
      borderRadius: '8px',
      padding: '10px',
      boxSizing: 'border-box',
    }
  });

interface POSearchFiltersProps {
  classes: any;
  handleClick: () => void;
  changeFocuses: () => void;
  openModalManualEntry?: () => void;
  userRole: UserRoleType;
  countWaitingList?: number;
  handleOpenWaitingList?: () => void;
  countUnrecognizedDocs?: number;
  handleShowUnrecognizedDocs?: () => void;
};

const poSearchFilters = (props: POSearchFiltersProps) => {

  const { classes } = props;
  return (
    <div className={ poSearchFiltersStyles.mainWrapper } >
      <div  className={ poSearchFiltersStyles.titleWrapper_sm }></div>
      <div className={ [poSearchFiltersStyles.titleWrapper, poSearchFiltersStyles.flexAndRow].join(' ') } >

        { props.userRole === UserRoleType.GHA &&
          <div className={ poSearchFiltersStyles.buttonWrapper }>

            <Grid container direction="row" className={ poSearchFiltersStyles.iconWrapper }>
              <Grid item xs={4} >
                <Grid container direction="column" className={poSearchFiltersStyles.alignMiddle} >
                  <Grid item className={ poSearchFiltersStyles.fs0 }>
                      <img alt="logo" src={ addIcon } className={ props.classes.manualEntryBtn }onClick={props.openModalManualEntry}/>                       
                  </Grid>
                  <Grid item>
                    <p className={ poSearchFiltersStyles.btnName }>Create New Order</p>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4} >
                <Grid container direction="column" className={poSearchFiltersStyles.alignMiddle} >
                  <Grid item >
                  <span><Badge className={ classes.badge } color="secondary" badgeContent={ props.countWaitingList }>
                    <img alt="logo" src={ waitlist } className={props.classes.manualEntryBtn} onClick={ props.handleOpenWaitingList }
                    />
                    </Badge>
                  </span>
                  </Grid>
                  <Grid item >
                    <p className={ poSearchFiltersStyles.btnName }> Waitlist</p>
                  </Grid>
                </Grid>

              </Grid>

              <Grid item xs={4} >
                <Grid container direction="column" className={poSearchFiltersStyles.alignMiddle} >
                  <Grid item >
                  <span><Badge className={ classes.badge } color="secondary" badgeContent={ props.countUnrecognizedDocs }>
                    <img alt="logo" src={ unrecognized } className={ [props.classes.manualEntryBtn, props.classes.unRecIcon].join(' ') } onClick={ props.handleShowUnrecognizedDocs }
                    />
                    </Badge>
                  </span>
                  </Grid>
                  <Grid item >
                    <p className={ poSearchFiltersStyles.btnName }> Un-Recognized Documents</p>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </div>
        }

      </div>

    </div>
  )
};

export default withStyles(styles)(poSearchFilters);